import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as reducers from '../../store/reducers';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

import Button from 'Components/Button';

class ContactLink extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      calledBeaconInit: false,
    };

    this.handleHelpClick = this.handleHelpClick.bind(this);
  }

  handleHelpClick(event) {
    event.preventDefault();
    if (typeof window.Beacon !== 'undefined') {
      if (!this.props.activeUser) window.Beacon('logout');
      window.Beacon('reset');
      window.Beacon('prefill', this.props.prefill || {});
      window.Beacon('open');
      window.Beacon('navigate', '/ask/message/');
      const { clickSideEffect } = this.props;
      if (typeof clickSideEffect === 'function') clickSideEffect();
    } else {
      window.location.href = 'mailto:support.schools@tinybop.com';
    }
  }

  render() {
    const { type, label, render } = this.props;
    if (typeof render === 'function') {
      return render(this.handleHelpClick);
    }

    if (type === 'button') {
      return (
        <Button
          label={label}
          buttonType="primary"
          additionalClasses={` Button--wide ${this.props.extraClass || ''}`}
          clickHandler={this.handleHelpClick}
        />
      );
    }
    return (
      <a
        href="mailto:schools.support@tinybop.com"
        className={`ContactLink ${this.props.extraClass || ''}`}
        onClick={e => this.handleHelpClick(e)}
      >
        {label}
      </a>
    );
  }
}

const mapStateToProps = state => {
  return {
    activeUser: reducers.getActiveUser(state),
  };
};

ContactLink.defaultProps = {
  label: <ConnectedFormattedMessage id="contact_link.default_cta" />,
};

ContactLink.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  render: PropTypes.func,
  type: PropTypes.string,
  extraClass: PropTypes.string,
  activeUser: PropTypes.object,
  prefill: PropTypes.object,
  clickSideEffect: PropTypes.func,
};

export default connect(mapStateToProps, {})(ContactLink);
